
import React from 'react'
import styled from "styled-components"
import ImageIGLS from './ImageIGLS'

const Titre = styled.a`
color:orange;
font-size: larger;
`
const ObjetIGLS = styled.div`
margin:0 auto;
padding:10px;
`
const ListeLiens = styled.div`
margin:20px auto;
padding:10px;
`

const Nom = styled.div`
padding:5px;
color:darkgray;
margin:10 auto;
`

const Meta = styled.div`
margin: 5px 15px;
width:100%;
`

const Note = styled.div`
margin: 10px;
padding: 10px;
border: 1px solid grey;
text-align: justify;
`


const affiche = (type, elem, liste) => {

    const tableauValeurs = {
        periode :[
            {
                valeur: 'hellenistique',
                libelle: 'époque hellénistique (IVe-Ier siècle avant Jésus-Christ)'
            },
            {
                valeur: 'romaine',
                libelle: 'époque romaine impériale (Ier-IIIe siècle après Jésus-Christ)'
            },
            {
                valeur: 'antiquite',
                libelle: 'antiquité tardive (IVe-VIIe siècle après Jésus-Christ)'
            },
            {
                valeur: 'islam',
                libelle: 'débuts de l’Islam (VIIe-VIIIe siècle après Jésus-Christ)'
            },
            {
                valeur: 'medieval',
                libelle: 'moyen Âge, époque moderne'
            },
            {
                valeur: 'non_precisee',
                libelle: 'non précisée'
            }
        ],
        contexte: [
            {
                valeur: 'ambiance',
                libelle: 'ambiance'
            },
            {
                valeur: 'archeologie',
                libelle: 'archéologie'
            },
            {
                valeur: 'conservation',
                libelle: 'conservation'
            },
            {
                valeur: 'epigraphiste_au_travail',
                libelle: 'epigraphiste au travail'
            },
            {
                valeur: 'folklore',
                libelle: 'folklore'
            },
            {
                valeur: 'paysage',
                libelle: 'paysage'
            },
            {
                valeur: 'portrait',
                libelle: 'portrait'
            }
        ],
        integrite: [
            {
                valeur: 'partiel',
                libelle: 'partiel'
            },
            {
                valeur: 'total',
                libelle: 'total'
            }
        ],
        conservation: [
            {
                valeur: 'bon',
                libelle: 'bon'
            },
            {
                valeur: 'mauvais',
                libelle: 'mauvais'
            }
        ],
        type_document: [
            {
                valeur: 'estampage',
                libelle: 'Estampage'
            },
            {
                valeur: 'calque',
                libelle: 'Calque'
            },
            {
                valeur: 'dessin',
                libelle: 'Dessin'
            },
            {
                valeur: 'diapositive',
                libelle: 'Diapositive'
            },
            {
                valeur: 'fiche',
                libelle: 'Fiche'
            },
            {
                valeur: 'negatif',
                libelle: 'Négatif'
            },
            {
                valeur: 'plaque_verre',
                libelle: 'Plaque de verre'
            },
            {
                valeur: 'carnet',
                libelle: 'Carnet'
            },
            {
                valeur: 'photo',
                libelle: 'Photo'
            }
        ],
    }

    const rechercheTableau = (type, valeur) => {
        //console.log("type: " + type)
        //console.log("valeur:")
        //console.log(valeur)

        for (const objet of tableauValeurs[type]){
            if (objet.valeur === valeur ){
                return (objet.libelle)
            }
        }
        return
    }

    //ajout du prefixe pour cle unique
    const unique = elem.id

    const afficheDocument = (document) => {
        const lien = `/document/${document.id}`
        const key = `${unique}-${document.id}`
        const keyLien = `Lien-${unique}-${document.id}`
        return ( <Meta key={key}><a key ={keyLien} href={lien}>{document.titre}</a> ({document.code_barre})</Meta>)
    }

    const afficheDonnee = (donnee) => {
        const lien = `/donnee/${donnee.id}`
        const key = `${unique}-${donnee.id}`
        const keyLien = `Lien-${unique}-${donnee.id}`
        return ( <Meta key={key}><a key ={keyLien} href={lien}>{donnee.nom_fichier}</a> ({donnee.type_donnee})</Meta>)
    }

    const afficheAuteur = (auteur) => {
        const lien = `/auteur/${auteur.id}`
        const key = `${unique}-${auteur.id}`
        const keyLien = `Lien-${unique}-${auteur.id}`
        return ( <Meta key={key}><a key ={keyLien} href={lien}>{auteur.prenom} {auteur.nom}</a></Meta>)
    }

    const afficheInscription = (inscription) => {
        const lien = `/inscription/${inscription.id}`
        const key = `${unique}-${inscription.id}`
        const keyLien = `Lien-${unique}-${inscription.id}`
        return ( <Meta key={key}><a key={keyLien} href={lien}>{inscription.titre} ({inscription.identifiant})</a></Meta>)
    }

    const afficheCollection = (collection) => {
        const lien = `/collection/${collection.id}`
        const key = `${unique}-${collection.id}`
        const keyLien = `Lien-${unique}-${collection.id}`
        return ( <Meta key={key}><a key={keyLien} href={lien}>{collection.libelle}</a></Meta>)
    }

    /*
    const afficheAction = (action) => {
        const lien = `/action/${action.id}`
        const key = `${unique}-${action.id}`
        const keyLien = `Lien-${unique}-${collection.id}`
        return ( <Meta key={key}><a key={keyLien} href={lien}>{action.type_action}</a></Meta>)
    }
    */

    const cle = (refElem) => {
        return (`${refElem}_${unique}`)
    }

    const elemHtml = (html) => {
        const htmlFormate = (typeof html === 'string')? html.replace(/\n/g, "<br/>") : ""
        return {__html: htmlFormate}
    }

    const url = (typeElement, id) => {
        let edit = "/edit"
        if (liste){
            edit=""
        }
        return (`/${typeElement}${edit}/${id}`)
    }

    const afficheOpentheso = (quoi, valeur) => {
        let lien = valeur.label
        if (valeur) {
            if (valeur.commentaire){
                lien = `${valeur.label} (${valeur.commentaire})`
            }
            return (<Meta key={cle(quoi)}><a key={valeur.uri} href={valeur.uri}>{lien}</a></Meta>)
        }
        return
    }

    const afficheElementBiblio = (type, elem_biblio) => {
        //console.log(type)
        //console.log(elem_biblio)
        let libelle = null
        switch (type) {
            case "page" :
                libelle = "page "
                break;
            case "numero" :
                libelle = "numéro "
                break
            case "planche" :
                libelle = "planche "
                 break
            case "figure" :
                libelle = "figure "
                break
            default :
        }
        if (elem_biblio && elem_biblio.length){
            return (" , " + libelle + elem_biblio)
        }
    }

    const afficheBiblio = (ref_biblio) => {
        const urlZotero = `https://www.zotero.org/groups/1843959/igls/items/${ref_biblio.uri}`
        return (<Meta key={cle("biblio" + ref_biblio.uri)}><a key={ref_biblio.uri} href={urlZotero} target= "_blank" rel="noreferrer noopener">
            {ref_biblio.label}
            {afficheElementBiblio("page", ref_biblio.page)}
            {afficheElementBiblio("numero", ref_biblio.numero)}
            {afficheElementBiblio("planche", ref_biblio.planche)}
            {afficheElementBiblio("figure", ref_biblio.figure)}
            </a></Meta>)
    }

    const parseJSON = (elem) => {
        if (elem) {
            if (typeof elem === 'string') {
                return (JSON.parse(elem))
            } else {
                return elem
            }
        } else {
            return null
        }
    }

    const parseJSONTableau = (elem) => {
        if (elem) {
            if (typeof elem === 'string') {
                return (JSON.parse(elem))
            } else {
                return elem
            }
        } else {
            return []
        }
    }

    const afficheFichierImage = (element) => {
        if (element.type_donnee.indexOf("image") !== -1){
            return <ImageIGLS id={element.id} typeImage={element.type_donnee}/>
        }
        return (<>Pas de fichier image...</>)
    }


    //initialisation des paragraphes
    let titre = null
    let metas = null

    let documents = elem.documents ? elem.documents.map(document => afficheDocument(document)) : null
    let donnees = elem.donnees ? elem.donnees.map(donnee => afficheDonnee(donnee)) : null
    let inscriptions = elem.inscriptions ? elem.inscriptions.map(inscription => afficheInscription(inscription)) : null
    let auteurs = elem.auteurs ? elem.auteurs.map(auteur => afficheAuteur(auteur)) : null

    let document = elem.document ? afficheDocument(elem.document) : null
    let donnee = elem.donnee ? afficheDonnee(elem.donnee) : null
    let inscription = elem.inscription ? afficheInscription(elem.inscription) : null
    let collection = elem.collection ? afficheCollection(elem.collection) : null
    let auteur = elem.auteur ? afficheAuteur(elem.auteur) : null

    switch (type){
        case 'auteur':
            titre = <>
                <Titre key={cle(type)} href={url(type, elem.id)}>{elem.nom} {elem.prenom} </Titre>
                </>
            metas = <>
                {elem.informations &&
                <><Nom>Informations: </Nom>
                <Note key={cle("meta_informations")} dangerouslySetInnerHTML={elemHtml(elem.informations)}></Note>
                </>}
                </>
            break
        case 'donnee':
            titre = <Titre key={cle(type)} href={url(type, elem.id)}>{elem.nom_fichier} </Titre>
            metas =<>
                {elem.contexte.length !== 0 && <><Nom>Contexte:</Nom><Meta key={cle("meta_contexte")}>{elem.contexte.map(contexte => rechercheTableau('contexte', contexte)).join(' - ')}</Meta></>}
                <Meta key={cle("categorie")}> {elem.type_donnee}</Meta>
                {afficheFichierImage(elem)}
            </>
            break
        case 'document':
            titre = <><Titre key={cle(type)} href={url(type, elem.id)}>{elem.titre} </Titre><br/></>
            metas =<>
                <Meta key={cle("identifiant")}> {elem.code_barre} - ({elem.inventaire}) </Meta>
                <Meta key={cle("type_doc")}> {elem.type_document} </Meta>
                <Nom>Type d'archive:</Nom><Meta key={cle("meta_type_document")}>{rechercheTableau('type_document', elem.type_document)}</Meta>
                <Nom>Intégrité:</Nom><Meta key={cle("meta_integrite")}>{rechercheTableau('integrite', elem.integrite)}</Meta>
                <Nom>État de conservation:</Nom><Meta key={cle("meta_conservation")}>{rechercheTableau('conservation', elem.conservation)}</Meta>
                {elem.commentaire && <><Nom>Commentaire:</Nom><Note key={cle("meta_commentaire")} dangerouslySetInnerHTML={elemHtml(elem.commentaire)}></Note></>}
            </>
            break
        case 'inscription':
            titre = <><Titre key={cle(type)} href={url(type, elem.id)}>{elem.titre} </Titre><br/></>
            metas = <>
                <Meta key={cle("meta_identifiant")}><Nom>Identifiant: </Nom>{elem.identifiant}</Meta>
                {elem.support && <Meta key={cle("meta_support")}><Nom>Support:</Nom>{afficheOpentheso("support", parseJSON(elem.support))}</Meta>}
                <Meta key={cle("lieu_origine")}><Nom>Lieu origine</Nom>
                {parseJSONTableau(elem.lieu_origine).map(lieu => afficheOpentheso("lieu_origine", parseJSON(lieu)))}</Meta>
                <Meta key={cle("lieu_conservation")}><Nom>Lieu conservation</Nom></Meta>
                {parseJSONTableau(elem.lieu_conservation).map((lieu, index) => afficheOpentheso(`lieu_conservation_${index}`, parseJSON(lieu)))}
                {elem.type_inscription && <Meta key={cle("meta_type_inscription")}><Nom>Type:</Nom>{afficheOpentheso("type_inscription", parseJSON(elem.type_inscription))}</Meta>}
                {elem.periode && <Meta key={cle("meta_periode")}><Nom>Période: </Nom>{rechercheTableau('periode', elem.periode)}</Meta>}
                {elem.langue && <Meta key={cle("meta_langue")}><Nom>Langue: </Nom>{elem.langue.join(' - ')}</Meta>}

                <Meta key={cle("ref_biblio")}><Nom>Références bibliographiques :</Nom></Meta>
                {parseJSONTableau(elem.biblio).map(ma_ref => afficheBiblio(ma_ref))}
                {elem.transcription && <><Nom>Transcription:</Nom><Note key={cle("meta_transcription")} dangerouslySetInnerHTML={elemHtml(elem.transcription)}></Note></>}
                {elem.traduction && <><Nom>Traduction:</Nom><Note key={cle("meta_traduction")} dangerouslySetInnerHTML={elemHtml(elem.traduction)}></Note></>}
                {elem.commentaire && <><Nom>Commentaire:</Nom><Note key={cle("meta_commentaire")} dangerouslySetInnerHTML={elemHtml(elem.commentaire)}></Note></>}
                </>
           break
           case 'collection':
            titre = <><Titre key={cle(type)} href={url(type, elem.id)}>{elem.libelle}</Titre><br/></>
            metas = <>
                <Nom>Sigle:</Nom><Meta key={cle("meta_sigle")}>{elem.sigle}</Meta>
                {elem.commentaire && <><Nom>Commentaire:</Nom><Note key={cle("meta_commentaire")} dangerouslySetInnerHTML={elemHtml(elem.commentaire)}></Note></>}
                </>
           break
           case 'action':
            console.log(elem.quoi)
            console.log(JSON.parse(elem.valeur))
            titre = <><Titre key={cle(type)} href={url(type, elem.id)}>{elem.type_action}</Titre><br/></>
            metas = <>
                <Nom>Valeur :</Nom><Meta key={cle("meta_valeur")}>{affiche(elem.quoi, JSON.parse(elem.valeur), false)}</Meta>
                <Nom>User :</Nom><Meta key={cle("meta_user")}>{affiche("user", elem.user, false)}</Meta>
                <Nom>Date :</Nom><Meta key={cle("meta_date")}>{elem.createdAt}</Meta>
                </>
            break
            case 'user':
                titre = <Titre key={cle(type)} href={url(type, elem.id)}>Utilisateur {elem.nom_complet} </Titre>
                metas =
                <>
                    <Meta key={cle("email")}>{elem.email}</Meta>
                    <Meta key={cle("role")}>{elem.role}</Meta>
                </>
                break
        default:
            break
    }


    return (<ObjetIGLS key={cle(type)}>
        {titre}
        {!liste && metas}

        {auteurs && auteurs.length ? <ListeLiens><span>Auteurs associés :</span> {auteurs} </ListeLiens> : null}
        {documents && documents.length ? <ListeLiens><span>Documents physiques associés :</span> {documents} </ListeLiens> : null}
        {donnees && donnees.length ? <ListeLiens><span>Données numériques associées :</span> {donnees} </ListeLiens>: null}
        {inscriptions && inscriptions.length ? <ListeLiens><span>Inscriptions associées :</span> {inscriptions} </ListeLiens>: null}

        {auteur ? <ListeLiens><span>Auteur/Contributeur associé :</span> {auteur} </ListeLiens> : null}
        {document ? <ListeLiens><span>Document physique associé :</span> {document} </ListeLiens> : null}
        {donnee ? <ListeLiens><span>Donnée numérique associée :</span> {donnee} </ListeLiens>: null}
        {inscription ? <ListeLiens><span>Inscription associée :</span> {inscription} </ListeLiens>: null}
        {collection ? <ListeLiens><span>Collection associée :</span> {collection} </ListeLiens>: null}

        </ObjetIGLS>)

}
/*  Composant qui assure l'ffichage d'un objet de type notice */
const Element = (params) => {

    const {type, elem, liste} = params
    return ( affiche(type, elem, liste))
}
export default Element